import * as React from "react";
import "./styles.scss";
import { Button, ButtonColour, ButtonSize } from "@trussle/external-components";

export interface ICTABannerProps {
  ctaLabel: string
  text: string
  onClick: () => void
}

export const CTABanner: React.FC<ICTABannerProps> = ({ ctaLabel, text, onClick }) => (
  <div className="ctaBanner">
    <h2 className="ctaBanner-text">{text}</h2>
    <Button
      classOverrides={{ button: "ctaBanner-button-ovr" }}
      colour={ButtonColour.Tertiary}
      size={ButtonSize.Medium}
      onClick={onClick}
    >
      {ctaLabel}
    </Button>
  </div>
);
